

export default {
    SET_KATEGORI_LIST(state, payload) {
        state.kategoriList = payload
    },
    SET_SUB_KATEGORI_LIST(state, payload) {
        state.subKategoriList = payload
    },
    SET_TOTAL(state, payload){
        state.totalRecords = payload
    },
    SET_KAT_TOTAL(state, payload){
        state.totalKatRecords = payload
    },
    SET_SUB_KAT_TOTAL(state, payload){
        state.totalSubKatRecords = payload
    },
    SET_ZAFIT_TOTAL(state, payload){
        state.totalZaFit = payload
    }
}
